import cx from 'classnames'
import * as React from 'react'

import styles from './date-input.module.scss'

type Props = {
  date: Date
  onClick: () => void
  selected: boolean
  inCurrentMonth: boolean
  disabled?: boolean
}

export default function Day({
  date,
  onClick,
  disabled = false,
  selected,
  inCurrentMonth,
}: Props) {
  const buttonRef = React.createRef<HTMLInputElement>()

  React.useEffect(() => {
    if (selected === true && buttonRef.current != null) {
      buttonRef.current.focus()
    }
  }, [selected, buttonRef])

  return (
    <td className={styles.day}>
      {/* eslint-disable-next-line jsx-a11y/role-supports-aria-props */}
      <button
        // @ts-expect-error
        ref={buttonRef}
        type="button"
        onClick={onClick}
        className={cx(styles['date-button'], {
          [styles.selected]: selected,
          [styles.disabled]: !inCurrentMonth,
        })}
        aria-selected={selected}
        tabIndex={selected ? 0 : -1}
        disabled={disabled}
      >
        {date.getDate()}
      </button>
    </td>
  )
}
